'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _domUtil = require('../../utils/domUtil');

var _keyConstants = require('../../utils/keyboard/keyConstants');

require('./LinkInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Constants


// Styles


var LinkInput = function (_React$Component) {
    _inherits(LinkInput, _React$Component);

    function LinkInput(props) {
        _classCallCheck(this, LinkInput);

        var _this = _possibleConstructorReturn(this, (LinkInput.__proto__ || Object.getPrototypeOf(LinkInput)).call(this, props));

        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleKey = _this.handleKey.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(LinkInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var setTempContent = this.props.setTempContent;

            // handle error

            var url = this.props.element.getIn(['content', 'temp', 'url']);
            var error = this.props.element.getIn(['content', 'temp', 'error']);

            var nextError = nextProps.element.getIn(['content', 'temp', 'error']);

            if (!error && nextError) {
                _reactDom2.default.findDOMNode(this.refs.linkContainer).focus();

                this.errorTime = setTimeout(function () {
                    setTempContent({ error: null, url: url });
                    _this2.errorTime = null;
                }, 2000);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            var _this3 = this;

            // focus on mount
            var error = this.props.element.getIn(['content', 'temp', 'error']);
            var oldError = oldProps.element.getIn(['content', 'temp', 'error']);

            if (this.props.isEditing && !oldProps.isEditing || this.props.isSelected && !oldProps.isSelected) {
                (0, _lodash.delay)(function () {
                    return _this3.refs.linkInput.focus();
                }, 10);
            }

            if (!this.props.isEditing && oldProps.isEditing || !this.props.isSelected && oldProps.isSelected) {
                this.refs.linkInput && this.refs.linkInput.blur();

                var url = this.props.element.getIn(['content', 'temp', 'url']);
                if (url) this.handleSubmit();
            }

            if (!error && oldError && this.props.isSelected) {
                this.refs.linkInput.focus();
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.props.startEditing();
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event && event.preventDefault();
            var url = this.props.element.getIn(['content', 'temp', 'url']);

            var _props = this.props,
                setLinkUrl = _props.setLinkUrl,
                setTempContent = _props.setTempContent;

            var validationResponse = setLinkUrl(url);

            if (validationResponse) {
                setTempContent({ error: validationResponse, url: url });
            }

            this.props.deselectAll();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            var setTempContent = this.props.setTempContent;

            setTempContent({ url: event.target.value });
        }
    }, {
        key: 'handleKey',
        value: function handleKey(event) {
            event.stopPropagation();
            var _props2 = this.props,
                element = _props2.element,
                setTempContent = _props2.setTempContent,
                stopEditing = _props2.stopEditing,
                moveElementToTrash = _props2.moveElementToTrash;


            if (event.which === _keyConstants.KEY_CODES.ESC) {
                return stopEditing();
            }

            var url = element.getIn(['content', 'temp', 'url']);
            var error = element.getIn(['content', 'temp', 'error']);

            if (!url && (event.which === _keyConstants.KEY_CODES.BACKSPACE || event.which === _keyConstants.KEY_CODES.DELETE)) {
                event.preventDefault();
                moveElementToTrash();
            }

            if (error) {
                if (this.errorTime) {
                    clearTimeout(this.errorTime);
                    this.errorTime = null;
                }

                return setTempContent({ error: null, url: url });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                isSelected = _props3.isSelected,
                element = _props3.element;

            var url = element.getIn(['content', 'temp', 'url']);
            var error = element.getIn(['content', 'temp', 'error']);
            var fetching = element.getIn(['attachment', 'fetching']);

            var inputError = _react2.default.createElement(
                'div',
                { className: 'error-message' },
                error && error.get('message') || 'URL not found'
            );

            var input = _react2.default.createElement(
                'div',
                { className: 'input-wrapper', onMouseDown: _domUtil.stopPropagationOnly, onClick: this.onClick },
                _react2.default.createElement('input', { onChange: this.handleChange,
                    onKeyDown: this.handleKey,
                    value: url || '',
                    ref: 'linkInput',
                    placeholder: 'Enter a URL...',
                    autoComplete: 'off',
                    autoCorrect: 'off',
                    autoCapitalize: 'off',
                    spellCheck: 'false',
                    disabled: !isSelected || fetching })
            );

            return _react2.default.createElement(
                'div',
                { className: 'LinkInput', onKeyDown: this.handleKey, ref: 'linkContainer', tabIndex: '-1' },
                _react2.default.createElement(
                    'form',
                    { className: 'link-form', onSubmit: this.handleSubmit },
                    error ? inputError : input
                )
            );
        }
    }]);

    return LinkInput;
}(_react2.default.Component);

LinkInput.propTypes = {
    element: _propTypes2.default.object,
    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    setLinkUrl: _propTypes2.default.func,
    setTempContent: _propTypes2.default.func,
    startEditing: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    moveElementToTrash: _propTypes2.default.func,
    deselectAll: _propTypes2.default.func
};

exports.default = LinkInput;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/LinkInput.js
// module id = 2000
// module chunks = 0